/**
 * Catalogue des Cabines — ambiances visuelles du membre.
 * Chaque cabine réécrit TOUTE la palette signature (papier, encre, or, teal, bordeaux)
 * sur <html> : comme le thème recolore déjà les classes Tailwind vers ces jetons,
 * le changement se voit sur chaque carte, icône, bouton et en-tête de l'app.
 * Règle absolue : toutes les cabines restent sur papier clair (jamais de dark mode).
 */
export const CABINES = [
  {
    id: 'parchemin',
    name: 'Parchemin',
    tagline: 'La cabine d’origine : papier crème, encre marine, filet d’or.',
    minLevel: 0,
    heading: "'Outfit', sans-serif",
    texture: 'radial-gradient(hsla(34,44%,50%,0.10) 1px, transparent 1.4px)',
    textureSize: '13px 13px',
    tokens: {
      '--ink': '218 48% 16%',
      '--ink-soft': '220 25% 31%',
      '--paper': '40 47% 96%',
      '--paper-2': '38 35% 92%',
      '--line': '41 30% 85%',
      '--gold': '34 44% 50%',
      '--gold-soft': '38 51% 84%',
      '--gold-bg': '41 67% 95%',
      '--gold-dark': '33 45% 38%',
      '--teal': '176 56% 28%',
      '--teal-soft': '167 27% 89%',
      '--teal-dark': '177 60% 21%',
      '--red-dossier': '8 54% 39%',
      '--muted-dossier': '223 11% 53%',
      '--background': '40 47% 96%',
      '--foreground': '218 48% 16%',
      '--card': '0 0% 100%',
      '--card-foreground': '218 48% 16%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '218 48% 16%',
      '--primary': '218 48% 16%',
      '--primary-foreground': '40 47% 96%',
      '--secondary': '38 35% 92%',
      '--secondary-foreground': '218 48% 16%',
      '--muted': '41 30% 85%',
      '--muted-foreground': '223 11% 53%',
      '--accent': '34 44% 50%',
      '--border': '41 30% 85%',
      '--input': '41 30% 85%',
      '--ring': '34 44% 50%',
      '--radius': '0.875rem',
    },
  },
  {
    id: 'etat-major',
    name: 'Carte d’État-Major',
    tagline: 'Quadrillage de cartographe, encre froide, angles nets, acier bleu.',
    minLevel: 0,
    heading: "'Outfit', sans-serif",
    texture:
      'linear-gradient(hsla(205,55%,30%,0.11) 1px, transparent 1px), linear-gradient(90deg, hsla(205,55%,30%,0.11) 1px, transparent 1px)',
    textureSize: '24px 24px, 24px 24px',
    tokens: {
      '--ink': '212 50% 18%',
      '--ink-soft': '212 28% 34%',
      '--paper': '45 22% 93%',
      '--paper-2': '45 16% 88%',
      '--line': '210 16% 76%',
      '--gold': '205 55% 32%',
      '--gold-soft': '205 35% 82%',
      '--gold-bg': '205 35% 93%',
      '--gold-dark': '205 60% 24%',
      '--teal': '192 48% 30%',
      '--teal-soft': '192 28% 88%',
      '--teal-dark': '192 55% 22%',
      '--red-dossier': '2 50% 42%',
      '--muted-dossier': '212 14% 44%',
      '--background': '45 22% 93%',
      '--foreground': '212 50% 18%',
      '--card': '46 26% 96%',
      '--card-foreground': '212 50% 18%',
      '--popover': '46 26% 96%',
      '--popover-foreground': '212 50% 18%',
      '--primary': '205 55% 32%',
      '--primary-foreground': '46 26% 96%',
      '--secondary': '45 16% 88%',
      '--secondary-foreground': '212 50% 18%',
      '--muted': '210 16% 84%',
      '--muted-foreground': '212 14% 44%',
      '--accent': '205 55% 32%',
      '--border': '210 16% 76%',
      '--input': '210 16% 76%',
      '--ring': '205 55% 32%',
      '--radius': '0.125rem',
    },
  },
  {
    id: 'quai-bordeaux',
    name: 'Quai de Bordeaux',
    tagline: 'Papier chaud, hachures du vieux port, terre cuite et sceau bordeaux.',
    minLevel: 0,
    heading: "Georgia, 'Times New Roman', serif",
    texture: 'repeating-linear-gradient(135deg, hsla(14,60%,38%,0.075) 0 2px, transparent 2px 10px)',
    textureSize: 'auto',
    tokens: {
      '--ink': '14 40% 19%',
      '--ink-soft': '14 22% 33%',
      '--paper': '26 52% 93%',
      '--paper-2': '26 40% 88%',
      '--line': '22 32% 80%',
      '--gold': '22 68% 44%',
      '--gold-soft': '26 60% 84%',
      '--gold-bg': '28 65% 94%',
      '--gold-dark': '14 60% 34%',
      '--teal': '92 24% 32%',
      '--teal-soft': '80 24% 87%',
      '--teal-dark': '95 30% 24%',
      '--red-dossier': '6 62% 38%',
      '--muted-dossier': '14 14% 42%',
      '--background': '26 52% 93%',
      '--foreground': '14 40% 19%',
      '--card': '30 55% 97%',
      '--card-foreground': '14 40% 19%',
      '--popover': '30 55% 97%',
      '--popover-foreground': '14 40% 19%',
      '--primary': '6 62% 32%',
      '--primary-foreground': '30 55% 97%',
      '--secondary': '26 40% 88%',
      '--secondary-foreground': '14 40% 19%',
      '--muted': '22 30% 85%',
      '--muted-foreground': '14 14% 42%',
      '--accent': '22 68% 44%',
      '--border': '22 32% 80%',
      '--input': '22 32% 80%',
      '--ring': '22 68% 44%',
      '--radius': '1.375rem',
    },
  },
  {
    id: 'port-attache',
    name: 'Port d’Attache',
    tagline: 'Embruns vert-de-gris, laiton poli, lumière de criée.',
    minLevel: 5,
    heading: "'Outfit', sans-serif",
    texture:
      'radial-gradient(circle at 15% 0%, hsla(176,60%,26%,0.14), transparent 45%), radial-gradient(circle at 85% 100%, hsla(34,55%,48%,0.12), transparent 45%)',
    textureSize: 'auto',
    tokens: {
      '--ink': '190 45% 15%',
      '--ink-soft': '190 24% 30%',
      '--paper': '168 32% 93%',
      '--paper-2': '168 24% 88%',
      '--line': '170 20% 78%',
      '--gold': '34 58% 46%',
      '--gold-soft': '38 45% 84%',
      '--gold-bg': '40 50% 94%',
      '--gold-dark': '32 60% 36%',
      '--teal': '176 60% 26%',
      '--teal-soft': '170 32% 87%',
      '--teal-dark': '177 65% 19%',
      '--red-dossier': '358 50% 40%',
      '--muted-dossier': '190 14% 40%',
      '--background': '168 32% 93%',
      '--foreground': '190 45% 15%',
      '--card': '170 38% 97%',
      '--card-foreground': '190 45% 15%',
      '--popover': '170 38% 97%',
      '--popover-foreground': '190 45% 15%',
      '--primary': '176 60% 24%',
      '--primary-foreground': '170 38% 97%',
      '--secondary': '168 24% 88%',
      '--secondary-foreground': '190 45% 15%',
      '--muted': '170 20% 85%',
      '--muted-foreground': '190 14% 40%',
      '--accent': '34 58% 46%',
      '--border': '170 20% 78%',
      '--input': '170 20% 78%',
      '--ring': '176 60% 26%',
      '--radius': '1.125rem',
    },
  },
  {
    id: 'brume-large',
    name: 'Brume du Large',
    tagline: 'Papier gris-bleu, acier poli, lumière froide du petit matin.',
    minLevel: 10,
    heading: "'Outfit', sans-serif",
    texture:
      'linear-gradient(180deg, hsla(210,35%,45%,0.14), transparent 220px), radial-gradient(hsla(210,30%,40%,0.07) 1px, transparent 1.3px)',
    textureSize: 'auto, 16px 16px',
    tokens: {
      '--ink': '215 34% 17%',
      '--ink-soft': '215 20% 33%',
      '--paper': '210 20% 93%',
      '--paper-2': '210 16% 88%',
      '--line': '212 16% 78%',
      '--gold': '199 54% 38%',
      '--gold-soft': '199 32% 84%',
      '--gold-bg': '200 36% 94%',
      '--gold-dark': '203 58% 28%',
      '--teal': '188 44% 32%',
      '--teal-soft': '188 26% 88%',
      '--teal-dark': '190 50% 23%',
      '--red-dossier': '348 46% 42%',
      '--muted-dossier': '215 13% 43%',
      '--background': '210 20% 93%',
      '--foreground': '215 34% 17%',
      '--card': '210 30% 97%',
      '--card-foreground': '215 34% 17%',
      '--popover': '210 30% 97%',
      '--popover-foreground': '215 34% 17%',
      '--primary': '215 38% 26%',
      '--primary-foreground': '210 30% 97%',
      '--secondary': '210 16% 88%',
      '--secondary-foreground': '215 34% 17%',
      '--muted': '212 16% 85%',
      '--muted-foreground': '215 13% 43%',
      '--accent': '199 54% 38%',
      '--border': '212 16% 78%',
      '--input': '212 16% 78%',
      '--ring': '199 54% 38%',
      '--radius': '0.5rem',
    },
  },
  {
    id: 'encre-nuit',
    name: 'Encre de Nuit',
    tagline: 'Papier crème, en-têtes d’encre marine et or vif. Réservée au sommet.',
    minLevel: 15,
    heading: "Georgia, 'Times New Roman', serif",
    texture:
      'radial-gradient(hsla(218,52%,11%,0.09) 1px, transparent 1.4px), linear-gradient(180deg, hsla(218,52%,11%,0.10), transparent 180px)',
    textureSize: '11px 11px, auto',
    tokens: {
      '--ink': '218 52% 11%',
      '--ink-soft': '220 28% 28%',
      '--paper': '38 40% 92%',
      '--paper-2': '38 32% 87%',
      '--line': '40 28% 80%',
      '--gold': '36 70% 50%',
      '--gold-soft': '38 60% 82%',
      '--gold-bg': '40 72% 93%',
      '--gold-dark': '34 62% 38%',
      '--teal': '176 50% 26%',
      '--teal-soft': '167 27% 88%',
      '--teal-dark': '177 56% 19%',
      '--red-dossier': '8 58% 38%',
      '--muted-dossier': '222 12% 46%',
      '--background': '38 40% 92%',
      '--foreground': '218 52% 11%',
      '--card': '0 0% 100%',
      '--card-foreground': '218 52% 11%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '218 52% 11%',
      '--primary': '218 52% 11%',
      '--primary-foreground': '36 70% 62%',
      '--secondary': '38 32% 87%',
      '--secondary-foreground': '218 52% 11%',
      '--muted': '40 28% 84%',
      '--muted-foreground': '222 12% 46%',
      '--accent': '36 70% 50%',
      '--border': '40 28% 80%',
      '--input': '40 28% 80%',
      '--ring': '36 70% 50%',
      '--radius': '0.875rem',
    },
  },
];

export const DEFAULT_CABINE = 'parchemin';

export const getCabine = (id) => CABINES.find((c) => c.id === id) || CABINES[0];

/** Applique une cabine sur <html> (palette complète + grain de fond + police des titres). */
export const applyCabine = (id) => {
  const cabine = getCabine(id);
  const root = document.documentElement;
  Object.entries(cabine.tokens).forEach(([token, value]) => root.style.setProperty(token, value));
  root.style.setProperty('--cabine-texture', cabine.texture);
  root.style.setProperty('--cabine-texture-size', cabine.textureSize);
  root.style.setProperty('--font-heading-cabine', cabine.heading);
  root.setAttribute('data-cabine', cabine.id);
};

export default CABINES;
